import { action, observable, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { ProductPartForm } from 'modules/product/forms';
import { ProductStore, MultiPackageProductStore } from 'modules/product/stores';
import _ from 'lodash';
import { sourceOfChange } from 'common/constants';
import { BaasicDropdownViewStore } from 'common/stores';

class AddExistingProductModalContentViewStore extends BaseViewStore {
	@observable isSaveClicked = false;

	addExistingProductForm = new ProductPartForm({
		onSuccess: async () => {
			await this.createProductCombination();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.productStore = new ProductStore(rootStore);
		this.modalParams = modalParams;
		this.multiPackageProductStore = new MultiPackageProductStore(rootStore);
		this.initialize();
	}

	@action initialize = async () => {
		this.suspend();
		this.productDropdownStore = new BaasicDropdownViewStore();
		await this.productDropdownStore.initialize({
			field: this.addExistingProductForm.$('productId'),
			store: new ProductStore(this.rootStore),
			filterProperties: {
				searchFields: 'mainSku',
				isMultiproduct: false,
				sellerIds: [this.modalParams.data.product.sellerId],
			},
			itemTemplate: {
				value: 'id',
				label: 'mainSku',
			},
		});
		this.resume();
	};

	@action.bound createProductCombination = async () => {
		this.isSaveClicked = true;
		const { productId, quantity } = this.addExistingProductForm.values();

		const multiPackageProduct = {
			parentProductId: this.rootStore.routerStore.routerState.params.id,
			productId,
			quantity,
		};

		await this.multiPackageProductStore.create(multiPackageProduct, sourceOfChange.createProductCombination);
		this.rootStore.notificationStore.success('PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.PRODUCTPARTADDSUCCESS');
	};

	@action.bound goBackToProductPartTypeSelection = () => {
		this.modalParams.data.openAddProductPartModal();
		this.modalParams.close();
	};
}

export default AddExistingProductModalContentViewStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/AddExistingProductModalContentViewStore.js